import React from "react";
import "./ArticlePreviewImageItem.css";
import ReactHtmlParser from "react-html-parser";
import {
  setPreviewingTextLineIDs,
  setPreviewingItemHidingMode,
  setPreviewingImageIDs
} from "../../redux/actions/editArticlePanel";
import { connect } from "react-redux";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";

class ArticlePreviewImageItem extends React.Component {
  constructor(props) {
    super(props);
    this.onHover = this.onHover.bind(this);

    this.onInvisibleClicked = this.onInvisibleClicked.bind(this);
    this.onHighlightClicked = this.onHighlightClicked.bind(this);
  }

  onHover(hovering) {
    const {
      item,
      setPreviewingTextLineIDs,
      setPreviewingImageIDs
    } = this.props;

    if (hovering) {
      setPreviewingTextLineIDs({ textLineIDs: item.textLineIDs });
      setPreviewingImageIDs({ imageIDs: [item.image.id] });
    } else {
      setPreviewingTextLineIDs({ textLineIDs: null });
      setPreviewingImageIDs({ imageIDs: null });
    }
  }

  onInvisibleClicked() {
    const { mode, item, setPreviewingItemHidingMode } = this.props;

    if (mode === "invisible") {
      setPreviewingItemHidingMode({ id: item.id, mode: null });
    } else {
      setPreviewingItemHidingMode({ id: item.id, mode: "invisible" });
    }
  }

  onHighlightClicked() {
    const { mode, item, setPreviewingItemHidingMode } = this.props;

    if (mode === "highlight") {
      setPreviewingItemHidingMode({ id: item.id, mode: null });
    } else {
      setPreviewingItemHidingMode({ id: item.id, mode: "highlight" });
    }
  }

  render() {
    const { item, mode } = this.props;
    const { image } = item;
    const text = item.text;

    if (image == null || image.id == null || image.id === "") {
      return null;
    }

    const imgUri = `${process.env.REACT_APP_API_ROOT}artworks/${
      image.id
    }/static`;

    return (
      <div style={{ position: "relative" }}>
        <div
          className="article_preview_image_container"
          onMouseEnter={() => this.onHover(true)}
          onMouseLeave={() => this.onHover(false)}
        >
          <img className="article_preview_image" alt={text} src={imgUri} />
          {text != null && text !== "" && (
            <span className="article_preview_image_caption">
              {ReactHtmlParser(text.replace(/\n/g, "<br>"))}
            </span>
          )}
        </div>
        <ButtonGroup
          style={{ position: "absolute", top: "20pt", right: "-70px" }}
          size="sm"
        >
          <Button
            variant={mode === "invisible" ? "dark" : "secondary"}
            style={{ margin: 0 }}
            onClick={this.onInvisibleClicked}
          >
            <span className="fa fa-eye-slash" />
          </Button>
          <Button
            variant={mode === "highlight" ? "dark" : "secondary"}
            style={{ margin: 0 }}
            onClick={this.onHighlightClicked}
          >
            <span className="fa fa-language" />
          </Button>
        </ButtonGroup>
      </div>
    );
  }
}

const mapDispatch = {
  setPreviewingTextLineIDs,
  setPreviewingImageIDs,
  setPreviewingItemHidingMode
};

const mapState = (state, ownProps) => {
  const { editArticlePanel } = state;
  const { previewHidingItemIDs } = editArticlePanel;

  return {
    mode: previewHidingItemIDs[ownProps.item.id]
  };
};

export default connect(
  mapState,
  mapDispatch
)(ArticlePreviewImageItem);
